import i18n from "../i18n";
import storeCountries from "../config/storeCountries.json";

export default function DropLi() {
  const t = (key) => i18n.t(key);

  const StoreCountries = storeCountries.map((country) => ({
  id: country.code,
  name: country.name,
  }));  

  const Gender = [
    { id: 1, name: t("male") },
    { id: 2, name: t("female") },
    { id: 3, name: t("other") },
  ];

  const SalesBy = [
    { id: 1, name: t("today") },
    { id: 2, name: t("thisWeek") },
    { id: 3, name: t("thisMonth") },
    { id: 4, name: t("thisYear") },
  ];

  const UnitType = [
    { id: 1, name: t("box") },
    { id: 2, name: t("pcs") },
    { id: 3, name: t("lb") },
    { id: 4, name: t("case") },
    { id: 5, name: t("pack") },
  ];

  const PaymentType = [
    { id: 1, name: t("fullPaid") },
    { id: 2, name: t("partiallyPaid") },
    { id: 3, name: t("due") },
  ];

  const PayType = [
    { id: 1, name: t("cash") },
    { id: 2, name: t("credit") },
    { id: 3, name: t("stripe") },
    { id: 4, name: t("check") },
    { id: 5, name: t("payLater") },
    { id: 6, name: t("split") },
    { id: 7, name: t("other") },
  ];

  const BoolType = [
    { id: 1, name: t("yes") },
    { id: 2, name: t("no") },
  ];

  const ReturnReason = [
    { id: 1, name: t("dateExpired") },
    { id: 2, name: t("badItem") },
    { id: 3, name: t("damage") },
    { id: 4, name: t("extra") },
    { id: 5, name: t("noSale") },
    { id: 6, name: t("others") },
  ];

  const Prefix = [
    { id: 1, name: t("mr") },
    { id: 2, name: t("mrs") },
    { id: 3, name: t("miss") },
  ];

  const Periodic = [
    { id: 1, name: t("daily") },
    { id: 2, name: t("weekly") },
    { id: 3, name: t("monthly") },
    { id: 4, name: t("yearly") },
  ];

  const Role = [
    { id: 1, name: t("admin") },
    { id: 2, name: t("manager") },
    { id: 3, name: t("cashier") },
  ];

  const PordType = [
    { id: 1, name: t("products") },
    { id: 2, name: t("category") },
    { id: 3, name: t("brands") },
  ];

    const RefundType = [
    { id: 1, name: t("ReturnMoney") },
    { id: 2, name: t("CustomerCredit") },
    { id: 3, name: t("ReduceBalance ") },
  ];

  return {
    SalesBy,
    UnitType,
    BoolType,
    PaymentType,
    PayType,
    ReturnReason,
    Gender,
    Prefix,
    Periodic,
    Role,
    PordType,
    StoreCountries,
    RefundType,
  };
}